export const calendar = {
  dayLabel: 'zi | zile',
  monthLabel: 'lună | luni',
  event: 'eveniment | evenimente',
  noRegisteredEvents: 'Nu există evenimente înregistrate',
  atThisDate: 'în această dată',
  loadingFailed: 'Încărcarea evenimentelor a eșuat',
  retry: 'Reîncearcă',

  toasts: {
    errorGetDatesOfInterestMessage: 'Încărcarea evenimentelor a eșuat',
    errorGetDatesOfInterestTitle: 'Eroare'
  }
}
